import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Pipe({ name: 'sanitize' })
export class HtmlSanitizerPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }
  
  transform(v: string) {
    return this._sanitizer.bypassSecurityTrustHtml(v);
  }

}



// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/shared/pipes/html-sanitizer.pipe.ts